import React, { useEffect, useRef } from 'react'

function MembershipsAndPublications({membershipsPublicationInfo, setMembershipsPublicationInfo, membershipCount, setMembershipCount, thesisDissertationsCount, setThesisDissertationsCount, authoredBooksMonographyCount, setAuthoredBooksMonographyCount, editedBooksMonographyCount, setEditedBooksMonographyCount, setWorksInProgressCount, worksInProgressCount,
    booksContributionFile, setBooksContributionFile, academicJournalFile, setAcademicJournalFile, refereedConferenceProceedingsFile, setRefereedConferenceProceedingsFile,
        nonrefereedConferenceProceedingsFile, setNonrefereedConferenceProceedingsFile, acceptedArticlesFile, setAcceptedArticlesFile, submittedManuscriptFile, setSubmittedManuscriptFile,
        creativeWorksFile, setCreativeWorksFile, technicalReportFile, setTechnicalReportFile,
        uploadedBooksContributionFile, setUploadedBooksContributionFile, uploadedAcademicJournalFile, setUploadedAcademicJournalFile, uploadedRefereedConferenceProceedingsFile, setUploadedRefereedConferenceProceedingsFile,
        uploadedNonrefereedConferenceProceedingsFile, setUploadedNonrefereedConferenceProceedingsFile, uploadedAcceptedArticlesFile, setUploadedAcceptedArticlesFile, uploadedSubmittedManuscriptFile, setUploadedSubmittedManuscriptFile,
        uploadedCreativeWorksFile, setUploadedCreativeWorksFile, uploadedTechnicalReportFile, setUploadedTechnicalReportFile
    }) {

    const bookContributionElement = useRef();
    const academicJournalElement = useRef();
    const refereedConferenceProceedingsElement = useRef();
    const nonrefereedConferenceProceedingsElement = useRef();
    const acceptedArticlesElement = useRef();
    const submittedManuscriptElement = useRef();
    const creativeWorksElement = useRef();
    const technicalReportElement = useRef();

    const handleChange = (e) =>{
        setMembershipsPublicationInfo({
            ...membershipsPublicationInfo, [e.target.name] : e.target.value
        });
    }
    const handleBookChange = (e) =>{
        setBooksContributionFile(e.target.files[0]);
        // setUploadedFiles(e.target.files[0]);
        console.log("New File");
        setMembershipsPublicationInfo({
            ...membershipsPublicationInfo, [e.target.name] : e.target.value
        });
    }
    const handleAcadJournalsChange = (e) =>{
        setAcademicJournalFile(e.target.files[0]);
        // setUploadedFiles(e.target.files[0]);
        console.log("New File");
        setMembershipsPublicationInfo({
            ...membershipsPublicationInfo, [e.target.name] : e.target.value
        });
    }
    const handleRefConfChange = (e) =>{
        setRefereedConferenceProceedingsFile(e.target.files[0]);
        // setUploadedFiles(e.target.files[0]);
        console.log("New File");
        setMembershipsPublicationInfo({
            ...membershipsPublicationInfo, [e.target.name] : e.target.value
        });
    }
    const handleNonRefConfChange = (e) =>{
        setNonrefereedConferenceProceedingsFile(e.target.files[0]);
        // setUploadedFiles(e.target.files[0]);
        console.log("New File");
        setMembershipsPublicationInfo({
            ...membershipsPublicationInfo, [e.target.name] : e.target.value
        });
    }
    const handleAceptedArticleChange = (e) =>{
        setAcceptedArticlesFile(e.target.files[0]);
        // setUploadedFiles(e.target.files[0]);
        console.log("New File");
        setMembershipsPublicationInfo({
            ...membershipsPublicationInfo, [e.target.name] : e.target.value
        });
    }
    const handleSubmittedManuChange = (e) =>{
        setSubmittedManuscriptFile(e.target.files[0]);
        // setUploadedFiles(e.target.files[0]);
        console.log("New File");
        setMembershipsPublicationInfo({
            ...membershipsPublicationInfo, [e.target.name] : e.target.value
        });
    }
    const handleCreativeWorkChange = (e) =>{
        setCreativeWorksFile(e.target.files[0]);
        // setUploadedFiles(e.target.files[0]);
        console.log("New File");
        setMembershipsPublicationInfo({
            ...membershipsPublicationInfo, [e.target.name] : e.target.value
        });
    }
    const handleTechnicalRepChange = (e) =>{
        setTechnicalReportFile(e.target.files[0]);
        // setUploadedFiles(e.target.files[0]);
        console.log("New File");
        setMembershipsPublicationInfo({
            ...membershipsPublicationInfo, [e.target.name] : e.target.value
        });
    }
    useEffect(() => {
        // console.log(signatureElement.current);
        bookContributionElement.current.files=uploadedBooksContributionFile;
        academicJournalElement.current.files=uploadedAcademicJournalFile;
        refereedConferenceProceedingsElement.current.files=uploadedRefereedConferenceProceedingsFile;
        nonrefereedConferenceProceedingsElement.current.files = uploadedNonrefereedConferenceProceedingsFile;
        acceptedArticlesElement.current.files = uploadedAcceptedArticlesFile;
        submittedManuscriptElement.current.files = uploadedSubmittedManuscriptFile;
        creativeWorksElement.current.files = uploadedCreativeWorksFile;
        technicalReportElement.current.files = uploadedTechnicalReportFile;
    }, [])
  return (
    <div className='flex flex-col box-border gap-4'>
        <div className='mb-3'>
            <h1 className='text-custom-blue font-bold text-2xl lg:text-3xl'>Memberships and Publications</h1>
        </div>
        <div className='flex flex-col box-border gap-4'>
            <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Membership of Professional Bodies with Dates</p>
            <div className='flex flex-col gap-4 justify-between'>
                {
                    Array.apply(null, {length: membershipCount}).map((e, i)=>(
                    <div key={i} className='flex flex-col gap-1 w-full box-border'>
                        <label className='text-custom-brown text-base' htmlFor={`professional_membership${i+1}`}>Professional Memberships {i+1}</label>
                        <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`professional_membership${i+1}`} id={`professional_membership${i+1}`} onChange={handleChange} value={membershipsPublicationInfo[`professional_membership${i+1}`]} />
                    </div>
                ))}
                <div className='flex gap-5 justify-end'>
                    {
                        membershipCount>1 ? 
                        <button type='button' onClick={()=>{setMembershipCount(membershipCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                            Remove Last
                        </button> : null
                    }
                    <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setMembershipCount(membershipCount+1)}>
                            Add More
                    </button>
                </div>
            </div>
        </div>
        <div className='flex flex-col box-border gap-4'>
            <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Thesis/Dissertations</p>
            <div className='flex flex-col gap-4 justify-between'>
                {
                    Array.apply(null, {length: thesisDissertationsCount}).map((e, i)=>(
                    <div key={i} className='space-y-4'>
                        <div className=' flex flex-col box-border gap-4 sm:gap-2 sm:flex-row'>
                            <div className='flex flex-col gap-1 sm:w-[49%] box-border'>
                                <label className='text-custom-brown text-base' htmlFor='Thesis_Dissertations_author'>Author</label>
                                <input className='border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`Thesis_Dissertations_author${i+1}`} id={`Thesis_Dissertations_author${i+1}`} onChange={handleChange} value={membershipsPublicationInfo[`Thesis_Dissertations_author${i+1}`]}/>
                            </div>
                            <div className='flex flex-col gap-1 sm:w-[49%] box-border'>
                                <label className='text-custom-brown text-base' htmlFor='Thesis_Dissertations_year'>Year</label>
                                <input className='border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type="number" min="1900" max="2099" step="1" name={`Thesis_Dissertations_year${i+1}`} id={`Thesis_Dissertations_year${i+1}`} onChange={handleChange} value={membershipsPublicationInfo[`Thesis_Dissertations_year${i+1}`]}/>
                            </div>
                        </div>
                        <div className='flex flex-col gap-1 w-full box-border'>
                            <label className='text-custom-brown text-base' htmlFor={`Thesis_Dissertations_title${i+1}`}>Title</label>
                            <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`Thesis_Dissertations_title${i+1}`} id={`Thesis_Dissertations_title${i+1}`} onChange={handleChange} value={membershipsPublicationInfo[`Thesis_Dissertations_title${i+1}`]} />
                        </div>
                    </div>
                ))}
                <div className='flex gap-5 justify-end'>
                    {
                        thesisDissertationsCount>1 ? 
                        <button type='button' onClick={()=>{setThesisDissertationsCount(thesisDissertationsCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                            Remove Last
                        </button> : null
                    }
                    <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setThesisDissertationsCount(thesisDissertationsCount+1)}>
                            Add More
                    </button>
                </div>
            </div>
        </div>
        <div className='flex flex-col box-border gap-4'>
            <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Books and Monographs</p>
            <div className='flex flex-col gap-4 justify-between'>
                <div className='flex flex-col box-border gap-4'>
                    <p className='text-custom-brown text-sm font-semibold sm:text-base'>(A) Authored</p>
                    {
                        Array.apply(null, {length: authoredBooksMonographyCount}).map((e, i)=>(
                        <div key={i} className='flex flex-col gap-1 w-full box-border'>
                            <label className='text-custom-brown text-base' htmlFor={`bm_authored${i+1}`}>Authored {i+1}</label>  {/*Authored*/}
                            <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`bm_authored${i+1}`} id={`bm_authored${i+1}`} onChange={handleChange} value={membershipsPublicationInfo[`bm_authored${i+1}`]} />
                        </div>
                    ))}
                    <div className='flex gap-5 justify-end'>
                        {
                            authoredBooksMonographyCount>1 ? 
                            <button type='button' onClick={()=>{setAuthoredBooksMonographyCount(authoredBooksMonographyCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                                Remove Last
                            </button> : null
                        }
                        <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setAuthoredBooksMonographyCount(authoredBooksMonographyCount+1)}>
                                Add More
                        </button>
                    </div>
                </div>
                <div className='flex flex-col box-border gap-4'>
                    <p className='text-custom-brown text-sm font-semibold sm:text-base'>(B) Edited</p>  {/*Monographs*/}
                    {
                        Array.apply(null, {length: editedBooksMonographyCount}).map((e, i)=>(
                        <div key={i} className='flex flex-col gap-1 w-full box-border'>
                            <label className='text-custom-brown text-base' htmlFor={`bm_edited${i+1}`}>Edit {i+1}</label>
                            <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`bm_edited${i+1}`} id={`bm_edited${i+1}`} onChange={handleChange} value={membershipsPublicationInfo[`bm_edited${i+1}`]} />
                        </div>
                    ))}
                    <div className='flex gap-5 justify-end'>
                        {
                            editedBooksMonographyCount>1 ? 
                            <button type='button' onClick={()=>{setEditedBooksMonographyCount(editedBooksMonographyCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                                Remove Last
                            </button> : null
                        }
                        <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setEditedBooksMonographyCount(editedBooksMonographyCount+1)}>
                                Add More
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div className='flex flex-col box-border gap-4'>
            <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Contribution in Books</p>
            <div className='flex flex-col gap-1 w-full box-border'>
                <label className='text-custom-brown text-base' htmlFor='book_contribution'>Upload filled excel document</label>
                <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='file' name='book_contribution' id='book_contribution' ref={bookContributionElement} onChange={handleBookChange} value={membershipsPublicationInfo.book_contribution} />
            </div>
        </div>
        <div className='flex flex-col box-border gap-4'>
            <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Published Journal Articles</p>
            <div className='flex flex-col gap-1 w-full box-border'>
                <label className='text-custom-brown text-base' htmlFor='academic_journal'>Upload filled excel sheet</label>
                <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='file' name='academic_journal' id='academic_journal' ref={academicJournalElement} onChange={handleAcadJournalsChange} value={membershipsPublicationInfo.academic_journal} />
            </div>
        </div>
        <div className='flex flex-col box-border gap-4'>
            <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Edited and Refereed Conference Proceedings</p>
            <div className='flex flex-col gap-4 justify-between'>
                <div className='flex flex-col box-border gap-4'>
                    <p className='text-custom-brown text-sm font-semibold sm:text-base'>(A) Refereed</p>
                    <div className='flex flex-col gap-1'>
                        <label className='text-custom-brown text-base' htmlFor='refereed_conference_proceedings'>Upload filled excel sheet</label>
                        <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='file' name='refereed_conference_proceedings' ref={refereedConferenceProceedingsElement} id='refereed_conference_proceedings' onChange={handleRefConfChange} value={membershipsPublicationInfo.refereed_conference_proceedings} />
                    </div>
                </div>
                <div className='flex flex-col box-border gap-4'>
                    <p className='text-custom-brown text-sm font-semibold sm:text-base'>(B) Non Refereed</p>
                    <div className='flex flex-col gap-1'>
                        <label className='text-custom-brown text-base' htmlFor='non_refereed_conference_proceedings'>Upload filled excel sheet</label>
                        <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='file' name='non_refereed_conference_proceedings' ref={nonrefereedConferenceProceedingsElement} id='non_refereed_conference_proceedings' onChange={handleNonRefConfChange} value={membershipsPublicationInfo.non_refereed_conference_proceedings} />
                    </div>
                </div>
            </div>
        </div>
        <div className='flex flex-col box-border gap-4'>
            <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Articles Accepted for Publication</p>
            <div className='flex flex-col gap-1 w-full box-border'>
                <label className='text-custom-brown text-base' htmlFor='accepted_articles'>Upload filled excel sheet</label>
                <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='file' name='accepted_articles' id='accepted_articles' ref={acceptedArticlesElement} onChange={handleAceptedArticleChange} value={membershipsPublicationInfo.accepted_articles} />
            </div>
        </div>
        <div className='flex flex-col box-border gap-4'>
            <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Manuscripts Submitted for Publication</p>
            <div className='flex flex-col gap-1 w-full box-border'>
                <label className='text-custom-brown text-base' htmlFor='submitted_manuscript'>Upload filled excel sheet</label>
                <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='file' name='submitted_manuscript' id='submitted_manuscript' ref={submittedManuscriptElement} onChange={handleSubmittedManuChange} value={membershipsPublicationInfo.submitted_manuscript} />
            </div>
        </div>
        <div className='flex flex-col box-border gap-4'>
            <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Creative Works/Patents</p>
            <div className='flex flex-col gap-1 w-full box-border'>
                <label className='text-custom-brown text-base' htmlFor='creative_works'>Upload filled excel sheet</label>
                <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='file' name='creative_works' id='creative_works' ref={creativeWorksElement} onChange={handleCreativeWorkChange} value={membershipsPublicationInfo.creative_works} />
            </div>
        </div>
        <div className='flex flex-col box-border gap-4'>
            <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Technical Report</p>
            <div className='flex flex-col gap-1 w-full box-border'>
                <label className='text-custom-brown text-base' htmlFor='technical_report'>Upload filled excel sheet</label>
                <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='file' name='technical_report' id='technical_report' ref={technicalReportElement} onChange={handleTechnicalRepChange} value={membershipsPublicationInfo.technical_report} />
            </div>
        </div>
        <div className='flex flex-col box-border gap-4'>
            <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Papers and Works in Progress</p>
            <div className='flex flex-col gap-4 justify-between'>
                {
                    Array.apply(null, {length: worksInProgressCount}).map((e, i)=>(
                    <div key={i} className='flex flex-col gap-1 w-full box-border'>
                        <label className='text-custom-brown text-base' htmlFor={`works_in_progress${i+1}`}>Paper/Work {i+1}</label>
                        <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`works_in_progress${i+1}`} id={`works_in_progress${i+1}`} onChange={handleChange} value={membershipsPublicationInfo[`works_in_progress${i+1}`]} />
                    </div>
                ))}
                <div className='flex gap-5 justify-end'>
                    {
                        worksInProgressCount>1 ? 
                        <button type='button' onClick={()=>{setWorksInProgressCount(worksInProgressCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                            Remove Last
                        </button> : null
                    }
                    <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setWorksInProgressCount(worksInProgressCount+1)}>
                            Add More
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default MembershipsAndPublications